import { Connection, ConnectionTypes, createConnectionFromJson } from '../models/Connection';
import { Repository } from './Repository';

interface CreateConversationParams {
  userId: string;
  text: string;
  currentUserId: string;
}

export class ConnectionRepository extends Repository {
  async createConversation(params: CreateConversationParams): Promise<Connection> {
    const path = 'v1/connections';

    try {
      const response = await Repository.client.post(path, {
        userId: params.userId,
        initialMessage: params.text
      });

      return createConnectionFromJson(response.data.data, {
        currentUserId: params.currentUserId,
        userId: params.userId
      });
    } catch (err) {
      throw err;
    }
  }

  async updateConnection(connectionId: string, status: ConnectionTypes) {
    const path = `v1/connections/${connectionId}`;

    const params = {
      status: status
    }
    await Repository.client.patch(path, params);
  }

  async getBlockedUserIds(): Promise<string[]> {
    const path = `v1/blocks`;
    const response = await Repository.client.get(path);
    const data = response.data?.data;
    return Array.isArray(data) ? data.filter((id): id is string => typeof id === 'string') : [];
  }

  async blockUser(userId: string) {
    const path = `v1/blocks`;
    await Repository.client.post(path, {
      blockedUserId: userId
    });
  }

  async unblockUser(userId: string) {
    const path = `v1/blocks`;
    await Repository.client.delete(path, {
      data: {
        blockedUserId: userId
      }
    });
  }

}

// Create a singleton instance
export const connectionRepository = new ConnectionRepository();
